export function constructInit(requiredFields: {}, optionalFields: {}, existingValues?: {}) {
    const init = {
        ...JSON.parse(JSON.stringify(requiredFields)),
        ...JSON.parse(JSON.stringify(optionalFields))
    }
    if (!!existingValues)
        Object.assignExists(init, existingValues)
    Object.trimLeaves(init, [null])
    return init
}